<template>
    <div class="download max-content">
        <van-nav-bar
            title="资料下载"
            left-arrow
            @click-left="onClickLeft"
        />
     
        <div class="buttons" v-if="meeting_id==598">
            <img style="width: 65%;" src="./images/14.png" @click="goInvite(4343)"/>
            <img style="width: 32%;" src="./images/15.png" @click="goInvite(4342)"/>
            <img style="width: 32%;" @click="skip(2556)"  src="//cdn.edstatic.com/203012120000/e499f34defa44b802e7f40aaecef0c7a/2025/07/b11b383c-e984-46ba-b7ae-739595064b0c.jpg" alt="">
        </div>
           <div class="buttons" v-if="meeting_id==483">
            <img style="width: 65%;" src="./images/14.png" @click="goInvite(4309)"/>
            <img style="width: 32%;" src="./images/15.png" @click="goInvite(4308)"/>
            <!-- <img src="//cdn.edstatic.com/203012120000/ac7eabf9b73441214a1b8775f74f46e3/2023/07/9f090e9e-2ab1-47af-a7da-d0d530526e9c.png"  @click="goInvite(4251)"/> -->
            <!-- <img src="//cdn.edstatic.com/203012120000/86edbacac5ba19443c9fe8ea70e2cce5/2023/07/bb175f44-0d93-4962-9dee-da2400b94c92.png" style="width:100%" @click="goInvite(4250)"/> -->
        </div>
        <img src="@/assets/images/cvscf2023/bottom.png" class="bottom"/>
    </div>
</template>

<script>
import Top from '../VascularSystem/components/Top.vue'
import { ButtonDetail } from '../../config/interface.js'
export default {
    components:{
        Top
    },
    data(){
        return{
            button_id:'',
            meeting_id:'598',

        }
    },
    created(){
        this.button_id=this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id;
        this.meeting_id=this.$route.query.meeting_id
        this.getButtonData();
    },
    methods:{
        goDetail(type){

        },
        //获取按钮信息
        getButtonData(){
            if(this.button_id){
                const url=ButtonDetail;
                let params={
                    button_id:this.button_id
                }
                const method="POST";
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        document.title=res.data.share_title;
                        if(common.is_weixin()){
                            let data=res.data;
                            common.wxShare(data.share_title,data.share_sub_title,data.share_img);
                        }
                    }
                })

            }
        },
        onClickLeft(){
            this.$router.go(-1)
        },
        skip(id){
			this.$router.push('/vascularNews/meeting/ppt?meeting_id='+this.meeting_id+'&button_id='+id)
            
        },
        goPPTs(){
			this.$router.push('/XVC/ppt?meeting_id='+this.meeting_id+'&button_id='+this.button_id)
        },
        goInvite(id){
			this.$router.push('/XVC/invite?meeting_id='+this.meeting_id+'&id='+id)
        }
    }
}
</script>

<style lang="scss" scoped>
.van-nav-bar{
    background: #d8261d;
    .van-icon{
        color: white;
    }
}
.van-nav-bar /deep/.van-icon {
    color: white;
}
 .van-nav-bar /deep/.van-nav-bar__title{
    color: white;
    font-size: 16px;
    letter-spacing: 0.5px;
}
.download{
    width:100%;
    height: 100vh;
    position: relative;
    .buttons{
        padding:15% 5%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        img{
            width: 45%;
            margin-bottom: 4%;
            border-radius:10px;
        }
    }
    .bottom{
        position: absolute;
        width: 100%;
        bottom: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/XVC/download.vue